// these are used in gatsby-node.js, so avoid using syntax that are not supported in nodejs

const chunk = (arr, size) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (v, i) => arr.slice(i * size, i * size + size))

/**
 * This converts the product json received from storefront API to UI readable product json.
 */
const extractProductJsonFromAPIProduct = (apiProductParam, maxWidth) => {
  return {
    ...apiProductParam,
    colors: apiProductParam.colors.map(item => {
      if (item.texture) {
        return {
          ...item,
          texture: extractImageJsonFromAPIImage(item.texture, 100),
        }
      }
      return item
    }),
    productImages: apiProductParam.productImages.map(productImage => {
      return {
        ...productImage,
        images: productImage.images.map(img => extractImageJsonFromAPIImage(img, maxWidth)),
      }
    }),
    productImagesVariant: (apiProductParam.productImagesVariant || []).map(productImage => {
      return {
        ...productImage,
        images: productImage.images.map(img => extractImageJsonFromAPIImage(img, maxWidth)),
      }
    }),
  }
}

// TODO: Based on use case need to keep updating srcset width options.
const extractImageJsonFromAPIImage = (apiImage, maxWidth) => {
  const { url } = apiImage
  const aspectRatio = apiImage.details.width / apiImage.details.height
  const reverseAspectRatio = 1 / aspectRatio
  const srcSetWidths = maxWidth === 1440 ? [360, 720, 1440, 1600] : [360, 720, 1440, 1600]
  const srcSetString = srcSetWidths
    .map(w => `${url}?w=${Math.ceil(w)}&h=${Math.ceil(w * reverseAspectRatio)}&q=50 ${w}w`)
    .join(',\n')
  const srcSetWebpString = srcSetWidths
    .map(w => `${url}?w=${Math.ceil(w)}&h=${Math.ceil(w * reverseAspectRatio)}&q=50&fm=webp ${w}w`)
    .join(',\n')
  return {
    fluid: {
      aspectRatio,
      sizes: `(max-width: ${maxWidth}px) 100vw, ${maxWidth}px`,
      src: `${url}?w=${maxWidth}&q=50`,
      srcSet: srcSetString,
      srcSetWebp: srcSetWebpString,
      srcWebp: `${url}?w=${maxWidth}&q=50&fm=webp`,
    },
    description: apiImage.description,
  }
}

const filterUnisexSubcollection = (val = {}, categorySlug, collectionSlug, subcollectionSlug) => {
  const filteredProducts = (val.products || []).map(product => {
    return filterUnisexProductImages(product, categorySlug, collectionSlug, subcollectionSlug)
  })
  return { ...val, products: filteredProducts }
}

const filterUnisexProductImages = (product, categorySlug, collectionSlug, subcollectionSlug) => {
  const newProductImages = product.productImages.map(productImage => {
    return {
      ...productImage,
      images: productImage.images.filter(image => {
        if (['women', 'men'].includes(image.description))
          return [categorySlug, collectionSlug, subcollectionSlug].includes(image.description)
        return true
      }),
    }
  })
  // filter products which don't have any images
  return {
    ...product,
    productImages: newProductImages.filter(imageSource => imageSource.images.length > 0),
  }
}

const zipObject = (props, values) => props.reduce((obj, prop, index) => ({ ...obj, [prop]: values[index] }), {})

const clone = obj => JSON.parse(JSON.stringify(obj))

const cleanIfNoReviews = obj => {
  const clonedObj = clone(obj)
  for (const key in clonedObj) {
    if (Array.isArray(clonedObj[key].reviews) && clonedObj[key].reviews.length === 0) {
      delete clonedObj[key]
    }
  }
  return clonedObj
}

const getTopProductReviewsForHomePage = (productIdReviewsMap, limit) => {
  if (limit == 0 || Object.keys(productIdReviewsMap).length == 0) return []
  let clonedMap = clone(productIdReviewsMap)
  const bucketSize = Math.max(parseInt(limit / Object.keys(productIdReviewsMap).length), 1)
  let outputReviews = []
  for (const productId in clonedMap) {
    if (clonedMap[productId].reviews) {
      outputReviews = outputReviews.concat(clonedMap[productId].reviews.splice(0, bucketSize))
    }
  }

  clonedMap = cleanIfNoReviews(clonedMap)

  if (limit == outputReviews.length) return outputReviews
  if (limit > outputReviews.length)
    return outputReviews.concat(getTopProductReviewsForHomePage(clonedMap, limit - outputReviews.length))
  return outputReviews.slice(0, limit)
}

const randomise = array => {
  const clonedArray = clone(array)
  let currentIndex = clonedArray.length
  let temporaryValue
  let randomIndex

  // While there remain elements to shuffle...
  while (currentIndex !== 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1

    // And swap it with the current element.
    temporaryValue = clonedArray[currentIndex]
    clonedArray[currentIndex] = clonedArray[randomIndex]
    clonedArray[randomIndex] = temporaryValue
  }

  return clonedArray
}

const arrangeColorsForProduct = (productsColors = {}, colorOrder = []) => {
  const colors = colorOrder.map(item => productsColors[item]).filter(c => c)
  const colorsNotInList = colorOrder.filter(col => !colors.find(item => item.name == col))
  colorsNotInList.forEach(item => {
    colors.push({ name: item, hexcode: null })
  })
  Object.keys(productsColors).forEach(productColor => {
    if (!colors.find(color => color.name == productColor)) {
      colors.push(productsColors[productColor])
    }
  })
  return colors
}

const decodeIdFromGraphQLResponse = (idResponse = '') => idResponse.toString().split('/').pop()

const getApplicableFiltersList = x => {
  if (x === 'Automated') {
    return 'color,price'
  }
  return 'color,price,size,material,construction,style,fabric'
}

module.exports = {
  chunk,
  extractProductJsonFromAPIProduct,
  extractImageJsonFromAPIImage,
  filterUnisexProductImages,
  filterUnisexSubcollection,
  zipObject,
  getTopProductReviewsForHomePage,
  randomise,
  arrangeColorsForProduct,
  decodeIdFromGraphQLResponse,
  getApplicableFiltersList,
}
